import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { CompanyDetailsComponent } from '../company-details.component';

@Component({
  selector: 'app-remove-branch',
  templateUrl: './remove-branch.component.html',
  styleUrls: ['./remove-branch.component.scss']
})
export class RemoveBranchComponent implements OnInit {

  @Input() branchData: any
  @ViewChild('closeBtn') closeBtn: ElementRef;
  errorMsg: boolean;
  
  constructor(private authService: AuthenticationService, private companyDetails: CompanyDetailsComponent, private appComp: AppComponent) { }

  ngOnInit(): void {
  }

  removeBranch(){
    this.appComp.loading = true;
    this.errorMsg = false;
    this.authService.removeBranch(this.branchData.id).then(res=>{
      console.log(res);
      this.companyDetails.getBranches(this.companyDetails.companyId);
      this.closeBtn.nativeElement.click();
      this.appComp.loading = false;
    }, err=>{
      console.log(err);
      
      this.errorMsg = true;
      this.appComp.loading = false;
    })

    
  }

}
